import { atom } from "recoil";

export const myFailedUploadsAtom = atom<any[]>({
    key: "uploads/myFailedUploads",
    default: [],
});